import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Flex, Heading, useDisclosure } from '@chakra-ui/react';
// import { NavLink } from 'react-router-dom';
import dayjs from 'dayjs';
// import { APP_ROUTES } from '_app/routes';
// import ConfirmationDialog from 'components/ConfirmationDialog';
import Table from 'components/Table';
// import { frontApi, API_ROUTES } from '_app/api';

// import ExpandedComponent from './components/ExpandedComponent';
import { useStores } from 'hooks/useStores';
import EditModal from './components/EditModal';

// import useBulkMutation from '_common/hooks/useBulkMutation';
// import useMutation from '_common/hooks/useMutation';
import { frontApi, API_ROUTES } from '_app/api';

const PostsPage = () => {
  const [isOpen, setIsOpen] = useState(null);

  const {
    postsStore: {
      data,
      fetchData,
      meta,
      isLoading,
      errors,
    },
  } = useStores();

  useEffect(() => {
    fetchData();
  }, []);


  const columns = React.useMemo(
    () => [
      {
        Header: 'title',
        accessor: 'title',
      },
      {
        Header: 'Created',
        accessor: row => dayjs(row.createdAt).format('DD.MM.YYYY'),
      },
      {
        Header: 'published',
        accessor: row => row.published.toString(),
      },
    ],
    []
  );

  const rowActions = [
    {
      label: 'Publish',
      onClick: async ({original}) => {

        const payload = {
          id: original.id,
          published: true,
        }

        await frontApi.put(API_ROUTES.posts, payload);

      },
    },
  ];

  return (
    <>
      <Flex justifyContent="space-between" mb={8}>
        <Heading>Posts</Heading>
        <Box>
          <Button colorScheme="blue" onClick={() => setIsOpen(true)}>
            Add
          </Button>
        </Box>
      </Flex>
      <Table {...{
        columns,
        data,
        fetchData,
        rowActions,
        isLoading,
        // expandableRows: true,
        // expandableRowsComponent: ExpandedComponent,
        // paginationServer: true,
        // paginationTotalRows: meta.totalItems,
      }} />
      <EditModal {...{ key: data.id, isOpen, onClose: () => setIsOpen(false) }} />
    </>
  );
};

export default observer(PostsPage);
